<template>
  <div class="card">
    <div class="card-body">
      <!-- Nav tabs -->
      <div class="row mb-2">
        <div class="col-lg-3 mb-2">
          <multiselect
            v-model="filters.status"
            label="name"
            track-by="value"
            @input="search"
            :options="filters.statusOptions"
            :searchable="false"
            :close-on-select="false"
            :allow-empty="false"
            :show-labels="false"
            placeholder="Կարգավիճակ"
          />
        </div>
      </div>
        <fieldset class="mb-3 pt-1" v-if="filters.type && filters.type.find(e => e == 'Պետական մրցակցային մրցույթներ')" >
          <legend>Պետական մրցակցային մրցույթներ</legend>
          <div class="row mb-3">
              <div class="col-lg-3" >
                <multiselect
                  class="mySelect"
                  v-model="filters.type2"
                  :options="filters.type2Options"
                  :searchable="false"
                  :close-on-select="false"
                  :show-labels="false"
                  :allow-empty="false"
                  placeholder="Պետական մրցույթի տիպ"
                />
              </div>
              <div class="col-lg-3">
                <multiselect
                  v-model="filters.procedure"
                  :options="filters.procedureOptions"
                  :searchable="false"
                  :close-on-select="false"
                  :show-labels="false"
                  :multiple="true"
                  placeholder="Պետական մրցույթի ընթացակարգ"
                />
              </div>
              <div class="col-lg-3">
                <multiselect
                  v-model="filters.price"
                  :options="filters.priceOptions"
                  :searchable="false"
                  :close-on-select="false"
                  :show-labels="false"
                  placeholder="Պետական մրցույթի ֊ 10մլն.-ից ցածր / բարձր"
                />
              </div>
          </div>
        </fieldset>
       
      <!-- Tab panes -->
      <div class="row">
        <div class="col-12 tenders-list">
          <div id="card">
            <v-server-table :url="tableDataUrl" :columns="columns" :options="options" ref="table">
                <template v-slot:viewed="{row}">
                  <div class="row">
                    <div class="col-6 row align-items-center">
                      <div v-if="!row.viewed" class="not-viewed-cicrcle"></div>
                    </div>
                    <div class="col-8" v-tooltip="'Առնչվող հայտարարություններ'">
                      <div v-tooltip="'Առնչվող հայտարարություններ'">
                        <button @click="() => $modal.show('tender-announcements-modal', {...row, handleGoToAnnouncement})" class="btn includer" style="background-color:transparent">
                            <i class="fa fa-link" aria-hidden="true"></i>
                            <span v-if="announcementsCount(row)" class="badge badge-primary">{{announcementsCount(row)}}</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-slot:tender_type="{row}">
                  {{row.type === 3 ? 'Պետական' : 'Մասնավոր'}}
                </template>
                <div slot="opening_finish_date" slot-scope="{row}" class="">
                  {{$moment(new Date(row.opening_date)).format('DD-MM-YYYY')}} - <br/><span class="text-primary font-weight-bold">{{$moment(new Date(row.finish_date)).format('DD-MM-YYYY HH:mm')}}</span>
                </div>
                <div slot="application" slot-scope="{row}" class="row justify-content-center ">
                  <template v-if="row.is_ended_electronic_link && row.kind !== 'private' && row.kind !== 'one_person'">
                    <div class="p-2">
                      <a target="_blank" :href="row.is_ended_electronic_link" class="link-primary">Դիտել արդյունքը</a>
                    </div>
                  </template>
                  <template v-if="row.is_competition">
                    <template v-if="row.kind === 'competitive'" >
                      <template v-if="me.package === 'Գոլդ' || me.package === 'Պրեմիում'">
                        <template v-if="!isNotNewProcedure(row)">
                          <button type="button" @click.stop="() => {$modal.show('application-modal', {...row, addToFavorite});setTenderViewed(row.id)}" class="btn btn-primary waves-effect waves-light float-right" data-toggle="modal" data-animation="bounce">
                              Մրցույթի հայտ
                          </button>
                      </template>
                      </template>
                      <template v-else>
                        <div v-tooltip="'Մրցույթի հայտ պատրաստելու գործիքը հասանելի է միայն Գոլդ կամ Պրեմիում փաթեթ ունեցող օգտատերերին'">
                          <button disabled type="button" class="btn btn-primary waves-effect waves-light float-right" data-toggle="modal" data-animation="bounce">
                            Մրցույթի հայտ
                          </button>
                        </div>
                      </template>
                    </template>
                    <template v-if="row.kind === 'one_person' && row.is_mine === false">
                      <button v-if="!row.is_ended" type="button" @click.stop="() => {$modal.show('suggestion-modal', {...row, resetComponent});setTenderViewed(row.id)}" class="btn btn-primary waves-effect waves-light float-right" data-toggle="modal" data-animation="bounce">
                        Գնային առաջարկ 
                      </button>
                      <button v-else type="button" @click="() => {$modal.show('result-modal', {...row, resetComponent})}" data-toggle="modal" data-animation="bounce" class="w-100 btn btn-primary waves-effect waves-light mr-2 d-flex justify-content-center align-items-center">
                        Տեսնել արդյունքները
                      </button>
                    </template>
                  </template>
                </div>
                <div slot="products" slot-scope="{row}" class="row justify-content-center">
                  <div class="col-12">
                      <span
                        :key="lot.toString() + lotIndex"
                        v-for="(lot, lotIndex) in row.rows.slice(0, 3)">
                          {{lot.name}}<span v-if="lotIndex !== row.rows.length-1">,</span>
                      </span>
                  </div>
                  <div v-if="row.rows.length > 3" class="col-12">
                    <span @click.stop="()=>{$modal.show('tender-rows-modal', {...row})}" class="text-primary" style="cursor: pointer">
                        Տեսնել բոլորը
                    </span>
                  </div>
                </div>
                <div slot="price" slot-scope="{row}" class="row justify-content-center">
                  <template v-if="me.package === 'Գոլդ'">
                      <!-- <template v-if="row.type === 'ELECTRONIC'">
                          
                      </template>
                      <template v-else> -->
                          <div class="col-12">
                              {{row.price}}
                          </div>
                          <div v-if="row.price_file" class="col-12">
                              <a download target="_blank" :href="row.price_file">
                                  <button type="button" @click="() => setTenderViewed(row.id)" class="btn btn-primary waves-effect waves-light" data-toggle="modal" data-animation="bounce">
                                  <i class="fa fa-download" />
                                  </button>
                              </a>
                          </div>
                      <!-- </template> -->
                  </template>
                  <template v-else>
                    <span v-tooltip="'Նախահաշվային գինը հասանելի է միայն Գոլդ փաթեթ ունեցող օգտատերերին'">
                      <i style="font-size: 24px"  class="fas fa-eye-slash"></i>
                    </span>
                  </template>
                </div>
                <div slot="invitation" slot-scope="{row}" class="d-flex justify-content-center">
                  <a v-if="row.kind !== 'one_person'" download target="_blank" :href="invitationLinkFix(row.invitation_link)">
                    <template v-if="me.package !== 'Անվճար' || !row.is_closed" >
                      <button type="button" @click="() => setTenderViewed(row.id)" class="btn btn-primary waves-effect waves-light float-right" data-toggle="modal" data-animation="bounce">
                        <i class="fa fa-download mr-1" /> Բեռնել
                      </button>
                    </template>
                    <template v-else>
                      <div v-tooltip="'Մրցույթի հրավերը բեռնելու համար թարմացրեք ձեր փաթեթի տեսակը'">
                        <button disabled type="button" @click="() => setTenderViewed(row.id)" class="btn btn-primary waves-effect waves-light float-right" data-toggle="modal" data-animation="bounce">
                          <i class="fa fa-download mr-1" /> Բեռնել
                        </button>
                      </div>
                    </template>
                  </a>
                  <button v-else-if="row.organize.contract !== ''" type="button" @click.stop="$modal.show('contract-draft-modal', row)" class="btn btn-primary waves-effect waves-light float-right" data-toggle="modal" data-animation="bounce">
                    Պայմանագիր
                  </button>
                  <div class="ml-1 row align-items-center" v-if="row.guaranteed">
                    <div class="col text-success">
                        <i style="font-size: 32px" class="fas fa-shield-alt"></i>
                    </div>
                  </div>
                </div>
                <div slot="type" slot-scope="{row}" class="d-flex justify-content-center">
                 {{row.type === "PAPER" ? 'Թղթային' : 'Էլեկտրոնային'}}
                </div>
                <div slot="favorite" slot-scope="{row}" class="d-flex justify-content-center">
                  <div class="star" :class="row.is_favorite && 'active-star'" @click="() => {toggleStar(row.id)}">
                    <a slot="icon" class="fa fa-star fa-lg"></a>
                  </div>
                </div>
            </v-server-table>
          </div>
        </div>
        <!-- end col -->
      </div>
    </div>
    <result-modal />
    <submitted-documents-modal />
    <application-modal from="favoriteTenders"/>
    <new-editor-modal />
    <tender-announcements-modal />
    <tender-rows-modal />
    <contract-draft-modal />
    <suggestion-modal />
  </div>
</template>
<script>
  import Multiselect from 'vue-multiselect'
  import ApplicationModal from '../tenders/modals/ApplicationModal.vue'
  import TenderRowsModal from '../tenders/modals/TenderRowsModal'
  import NewEditorModal from '@/views/fileManagment/application/NewEditorModal'
  import SubmittedDocumentsModal from '../tenders/modals/SubmittedDocumentsModal'
  import SuggestionModal from '../tenders/modals/SuggestionModal'
  import ContractDraftModal from './modals/ContractDraftModal'
  import TenderAnnouncementsModal from '../tenders/modals/TenderAnnouncementsModal'
  import ResultModal from '../suggestions/modals/ResultModal'

  export default {
    name: 'favoriteTenders',
    components: {
      TenderRowsModal,
      ContractDraftModal,
      SuggestionModal,
      Multiselect,
      ApplicationModal,
      NewEditorModal,
      SubmittedDocumentsModal,
      TenderAnnouncementsModal,
      ResultModal
    },
    data() {
      return {
        tableDataUrl: `${process.env.VUE_APP_API_URL}tender/get/favorite`,
        columns: [
          'viewed',
          'password',
          'title',
          'organizator',
          'products',
          'opening_finish_date',
          'price',
          'region',
          'type',
          'application',
          'invitation',
          'favorite'
        ],
        options: {
          sortable: [],
          hiddenColumns: ['region', 'type'],
          requestFunction(data) {
            return this.$client.get(this.url, {params: data})
            .catch(function (e) {this.dispatch('error', e)})
          },
          columnsDropdown: true,
          pagination: { chunk: 1 },
          filterByColumn: false,
          customFilters: [ 'status' ],
          skin: 'table table-hover',
          headings: {
            viewed: '',
            password: 'Ծածկագիր',
            title: 'Անվանում',
            organizator: 'Պատվիրատու',
            products: 'Գնման առարկաներ',
            region: 'Տարածաշրջան',
            category: 'Խումբ / Կատեգորիա',
            type: 'Տիպ',
            opening_finish_date: 'Ժամկետը սկիզբ/ավարտ',
            price: 'Նախահաշվային գին',
            application: 'Դիմել',
            invitation: 'Մրցույթի հրավեր',
            favorite: 'Նախընտրել',
          },
          texts: {
            count:
            'Ցուցադրված է {from}֊ից {to}֊ը ընդհանուր {count} տողից|{count} տող|',
            first: 'Առաջին',
            last: 'Վերջին',
            filter: '',
            filterPlaceholder: 'Փնտրել',
            limit: '',
            page: 'Page:',
            noResults: 'Համընկնում չի գտնվել',
            noRequest: 'խնդրում ենք ընտրել առնվազն մեկ ֆիլտեր տվյալները ներբեռնելու համար',
            filterBy: 'փնտրել ըստ {column}',
            loading: 'Բեռնվում է...',
            defaultOption: 'ընտրել {column}',
            columns: 'Ընտրել դաշտերը',
          },
        },
        filters: {
          category: { name: 'Բոլորը', value: 'all' },
          categoryOptions: [
            { name: 'Բոլորը', value: 'all' },
            { name: 'Միայն իմ կատեգորիաները', value: 'onlyMy' },
            { name: 'Իմ դիմածները', value: 'applied' },
          ],
          status: { name: 'Բոլորը', value: 'all' },
          statusOptions: [
            { name: 'Բոլորը', value: 'all' },
            { name: 'Ակտիվ մրցույթներ', value: 'active' },
            { name: 'Ավարտված մրցույթներ', value: 'finished' },
          ],
          type: null,
          typeOptions: ['Պետական մրցակցային մրցույթներ', 'Պետական մեկ անձի մրցույթներ', 'ՀՀ֊ից դուրս մրցույթներ', 'Ոչ պետական մրցույթներ', 'iTender մրցույթներ' ],
          type2: null,
          type2Options: ['Բոլորը','Թղթային', 'Էլեկտրոնային'],
          procedure: null,
          procedureOptions: ['ԳՀ', 'ԲՄ', 'ՀԲՄ', 'ՀՄԱ', 'ԷԱՃ'],
          region: null,
          regionOptions: [
            'Երևան',
            'Արագածոտն',
            'Արարատ',
            'Արմավիր',
            'Գեղարքունիք',
            'Լոռի',
            'Կոտայք',
            'Շիրակ',
            'Սյունիք',
            'Վայոց ձոր',
            'Տավուշ',
          ],
          price: null,
          priceOptions: ['Բոլորը', '10մլն.-ից ցածր', '10մլն.-ից բարձր'],
        }
      }
    },
    computed: {
      me() {
        return this.$store.getters['user/me']
      },
      allTenders() {
        return this.$store.getters['organize/allOrganizes']
      }
    },
    mounted(){
      this.$client.get('tender/filterOptions').then(({data}) => {
        if(data.columns){
          this.options.hiddenColumns = Object.entries(data.columns).filter(item => item[1] === 0).map(item => item[0])
        }
      })
    },
    methods: {
      consoleLog(msg) {
        console.log(msg)
      },
      invitationLinkFix(link){
        if(link.includes('https://gnumner.am')){
          return link.replace("https://gnumner.am/", "https://gnumner.minfin.am/");
        }
        return link;
      },
      isNotNewProcedure(row){
        switch (row.procedure.id) {
          case 8:
          case 9:
          case 10:
          case 11:
          case 12:
              return true
          default:
              return false
        }
      },
      isEndedElectronic(tender){
        console.lof(tender)
      },
      announcementsCount(row){
        const announcementsCount = row.announcements_count
        const tenderAnnouncementsCount = row.tender_state_id !== 0 ? row.tender_announcements_count : 0;
        return announcementsCount + tenderAnnouncementsCount
      },
      handleGoToAnnouncement(announcementId){
        this.$router.push({ path: `/participant/tenders?id=${announcementId}` })
      },
      search() {
        if(this.filters.status){
          this.$refs.table.customQueries.status = this.filters.status.value;
        }
        this.$refs.table.refresh();
      },
      toggleStar(tenderStateId){
        this.$client.post('/tender/favorite', {tender_state_id: tenderStateId})
        const currTender = this.$refs.table.data.find(tender => tender.id === tenderStateId)
        currTender.is_favorite = !currTender.is_favorite
      },
      addToFavorite(tenderStateId){
        const currTender = this.$refs.table.data.find(tender => tender.id === tenderStateId)
        if(!currTender.is_favorite){
          currTender.is_favorite = true;
          this.$client.post('/tender/favorite', {tender_state_id: tenderStateId})
        }
      },
    },
  }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
  .date-bloc span {
    font-size: 12px;
  }
  .mySelect .multiselect__tags{
    color: #1e7bb7;
    background-color: #1e7bb7;
  }
</style>
<style>
  legend{
    width: auto;
    margin: 0 10px;
    font-size: 14px;
  }
  fieldset{
    border-top: 1px solid #b3b3b3;;
    border-bottom: 1px solid #b3b3b3;;
  }
  .star{
    cursor: pointer;
  }
  .active-star{
    color: rgb(255, 165, 0);
  }
  .tenders-list th, .tenders-list td{
    max-width: 300px;
  }
</style>